
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class Home extends Vue {
    username = '';
    password = '';
    error = false;

    private async handleSubmit(e: Event): Promise<void> {
        e.preventDefault();

        this.error = false;
        if (this.username === '' || this.password === '') {
            this.error = true;
            return;
        }

        const credentials = {
            username: this.username,
            password: this.password,
        };

        try {
            const response = await this.$store.dispatch('auth/login', credentials);
            if (response === true) {
                this.$router.replace({ name: 'maps' });
            } else {
                this.error = true;
            }
        } catch {
            this.error = true;
        }
    }
}
